import React from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'

export const Text = styled.p`
  color: black;
  font-family: Heebo;
  font-style: normal;
  font-size: 16px;
  line-height: 23px;
`

export const Title = styled.h1`
  font-family: Heebo;
  font-style: 500;
  font-weight: normal;
  font-size: 42px;
  line-height: 52px;
  font-weight: 500;
  color: white;
`

export const CTA = styled.a`
  color: #ff547d;
  font-size: 18px;
  line-height: 26px;
  text-decoration: none;
`

export const bgColor = '#2c0b41'

export const BlogImg = props => {
  return (
    <>
      {props.media && props.media.localFile && (
        <Img
          objectFit="cover"
          objectPosition="50% 50%"
          style={props.style}
          fluid={props.media.localFile.childImageSharp.fluid}
        />
      )}
    </>
  )
}

export const PageLink = styled.a`
  font-family: Heebo;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  text-decoration: none;
  color: #949494;
  margin-right: 25px;
`

export const CategoryText = styled.h4`
  font-family: Heebo;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #ff2b5e;
  text-transform: uppercase;
  margin-top: 18px;
  margin-bottom: 0;
`
